module.exports = __webpack_public_path__ + "img/mortarboard.1516e171.svg";